import * as React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * sonner is imperative: a resolved string handed to `toast(...)` is never
 * re-rendered, so a toast outlives a language change with the old text. Passing
 * this node instead lets it resolve its own key and follow the switch.
 */
export const LocalizedToastText: React.FC<{ messageKey: string }> = ({ messageKey }) => {
  // sonner renders this with no Suspense boundary above it. Bundles are inlined
  // today, so the hook never suspends; keep it that way if they ever load lazily.
  const { t } = useTranslation(undefined, { useSuspense: false });
  return <>{t(messageKey)}</>;
};
